import {PropertyPageTableHeader} from "../../../styles/Wrappers";
import {GeneralInformationContainer} from "../../../components/GeneralInformationContainer";
import React, {FC} from "react";
import styled from "styled-components";
import {Accessibility} from "../../../models/Accessibility";
import {useStorageData} from "../../../hooks/useStorageData";

const StyledBody = styled.tbody`
  width: 100vw
`

const StyledTr = styled.tr`
  width: 100vw
`

type PropsType = {
  id: string
  name: string
  title: string
  accessibilities:  Accessibility[] | undefined
  onSetRef: (r: HTMLTableHeaderCellElement | null) => void
}

const ElementOfTable: FC<PropsType> = ({
  id,
  name,
  title,
  accessibilities,
  onSetRef
}) => {
  const disabilityTypes: string[] = useStorageData('disability_types')

  const getFilteredAccessibilities = () => {
    let array = []
    if (accessibilities) {
      array = accessibilities.filter((unit) => unit.accessibility_unit === id);
      if (array.length > 0 && disabilityTypes?.length > 0) {
        array = array.filter((i) => {
          if (i.disability_types) {
            return disabilityTypes.some((dt) => i.disability_types.includes(dt))
          } else {
            return false
          }
        })
      }

      return array.map((el) => (
        <GeneralInformationContainer
          padding={'10px'}
          key={el.id}
          text={`${el.item_title} - ${el.attribute_title}`}
        />
      ))
    }
    return []
  }

  const filteredAccessibilities = getFilteredAccessibilities()

  return (
    <table key={id} id={id} ref={(r: any) => onSetRef(r)}>
      {filteredAccessibilities.length > 0 ? (
        <StyledBody>
          <StyledTr>
            <PropertyPageTableHeader>
              {title} - {name}
            </PropertyPageTableHeader>
          </StyledTr>
          {filteredAccessibilities}
        </StyledBody>
      ) : (<></>)}
    </table>
  )
}

export default ElementOfTable
